<template>
    <div :style="{paddingTop: paddingTop+'px'}" class="login">
        <div class="logo">
            <img alt="efoto" src="../assets/efoto.png"/>
            <p>专业图片服务平台</p>
        </div>
        <div class="form">
            <template v-if="passwordMode">
                <a-form-model :model="form" :rules="rules" layout="vertical">
                    <a-form-model-item label="手机号码" prop="mobile">
                        <a-input placeholder="请输入手机号码" v-model="form.mobile">
                            <a-icon slot="prefix" style="color:rgba(0,0,0,.25)" type="mobile"/>
                        </a-input>
                    </a-form-model-item>
                    <a-form-model-item label="安全密码" prop="password">
                        <a-input type="password" placeholder="请输入安全密码" v-model="form.password">
                            <a-icon slot="prefix" style="color:rgba(0,0,0,.25)" type="lock"/>
                            <a @click="mode='forget'" slot="suffix">忘记密码 ?</a>
                        </a-input>
                    </a-form-model-item>
                    <a-form-model-item>
                        <SaveButton :action="loginSubmit" :disabled="loginDisabled" title="登录"/>
                    </a-form-model-item>
                </a-form-model>
                <div class="switch" @click="mode='register'">没有账号？立即注册</div>
            </template>
            <template v-else-if="!logined">
                <a-form-model :model="form" :rules="rules" layout="vertical">
                    <a-form-model-item label="手机号码" prop="mobile">
                        <a-input placeholder="请输入手机号码" v-model="form.mobile">
                            <a-icon slot="prefix" style="color:rgba(0,0,0,.25)" type="mobile"/>
                        </a-input>
                    </a-form-model-item>
                    <a-form-model-item label="验证码" prop="password">
                        <a-input placeholder="请输入短信验证码" v-model="form.password">
                            <a-icon slot="prefix" style="color:rgba(0,0,0,.25)" type="lock"/>
                            <VueCodeButton :disabled="codeDisabled" @click="sendCode" class="code-button" slot="suffix"/>
                        </a-input>
                    </a-form-model-item>
                    <a-form-model-item>
                        <SaveButton :action="loginSubmit" :disabled="loginDisabled" title="登录"/>
                    </a-form-model-item>
                </a-form-model>
                <div class="switch" @click="mode='password'">已有账号？立即登录</div>
            </template>
            <template v-else>
                <a-form-model :model="reset" :rules="resetRules" layout="vertical">
                    <a-form-model-item label="设置密码" prop="new_password">
                        <a-input type="password" placeholder="设置密码，至少8位长度且包含数字和字母" v-model="reset.new_password">
                            <a-icon slot="prefix" style="color:rgba(0,0,0,.25)" type="mobile"/>
                        </a-input>
                    </a-form-model-item>
                    <a-form-model-item label="密码确认" prop="password_cfm">
                        <a-input type="password" placeholder="再次输入，至少8位长度且包含数字和字母" v-model="reset.password_cfm">
                            <a-icon slot="prefix" style="color:rgba(0,0,0,.25)" type="lock"/>
                        </a-input>
                    </a-form-model-item>
                    <a-form-model-item>
                        <SaveButton :action="setPassword" :disabled="resetDisabled" title="登录"/>
                    </a-form-model-item>
                </a-form-model>
                <div class="switch" @click="mode='password'">已有账号？立即登录</div>
            </template>
            <div style="text-align:center;">
                登录代表同意
                <a href="javascript:window.open('https://gm.efoto.me/term/user-service')">《EFOTO用户协议》</a>
                及
                <a href="javascript:window.open('https://gm.efoto.me/term/user-privacy')">《隐私政策》</a>
            </div>
        </div>
        <footer>Copyright © 2020 杭州盈动体育文化有限公司</footer>
        <UseElectron ref="useElectron"/>
    </div>
</template>

<script>
    import api from "../utils/api";
    import func from "../utils/func";
    import enums from "../utils/enums";
    import {VueCodeButton} from "@basic/vue-code";
    import "@basic/vue-code/dist/vue-code.css";
    import SaveButton from "../comps/SaveButton";
    import UseElectron from "../comps/UseElectron";

    export default {
        components: {UseElectron, SaveButton, VueCodeButton},
        data() {
            return {
                mode: "password",
                form: {
                    mobile: "",
                    password: "",
                    platform: enums.Platform,
                },
                rules: {
                    mobile: [{required: true, message: "请输入您的手机号码"}],
                    password: [{required: true, message: "请输入您的安全密码"}],
                },
                reset: {
                    new_password: "",
                    password_cfm: ""
                },
                resetRules: {
                    new_password: [{required: true, message: "设置密码，至少8位长度且包含数字和字母"}],
                    password_cfm: [{required: true, message: "再次输入，至少8位长度且包含数字和字母"}],
                },
                logined: false,
                codeDisabled: true,
                loginDisabled: true,
                resetDisabled: true,
            };
        },
        watch: {
            form: {
                deep: true,
                handler(nv) {
                    this.codeDisabled = !func.isMobile(nv.mobile);
                    this.loginDisabled = this.codeDisabled || (nv.password === "") ||
                        (this.passwordMode && !(nv.password.length >= 8 && isNaN(nv.password)));
                },
            },
            reset: {
                deep: true,
                handler(nv) {
                    this.resetDisabled = !((nv.new_password.length >= 8) && (nv.password_cfm === nv.new_password) && isNaN(nv.new_password));
                }
            }
        },
        computed: {
            passwordMode() {
                return this.mode === "password";
            },
            paddingTop() {
                return Math.min((this.$store.state.layout.clientHeight - 570) / 3, 100);
            }
        },
        mounted() {
            this.$refs.useElectron.open(false);
        },
        methods: {
            sendCode() {
                api.v1.auth.sendCode(this.form.mobile);
            },
            loginSubmit() {
                const self = this;
                return api.v1.auth.loginSubmit(this.form)
                    .then(() => {
                        if (self.passwordMode) {
                            let refer = self.$route.query.refer;
                            self.$router.push({name: refer ? refer : "Index"})
                                .catch(() => {
                                    self.$router.push({name: "Index"});
                                });
                        } else {
                            self.logined = true;
                        }
                    });
            },
            setPassword() {
                const self = this;
                return api.v1.user.setPassword(this.reset)
                    .then(() => {
                        let refer = self.$route.query.refer;
                        self.$router.push({name: refer ? refer : "Index"})
                            .catch(() => {
                                self.$router.push({name: "Index"});
                            });
                    });
            }
        }
    };
</script>

<style lang="less" scoped>
    .login {
        margin: 0 auto;
        text-align: center;

        .logo {
            img {
                height: 48px;
                margin-bottom: 15px;
            }

            p {
                font-size: 18px;
                font-weight: bold;
                letter-spacing: 2px;
            }
        }

        .form {
            width: 420px;
            padding: 40px 40px 15px 40px;
            background: #fff;
            border-radius: 10px;
            margin: 50px auto 0;
            box-shadow: 0 0 20px 10px #eee;
            text-align: left;


            .code-button {
                margin-right: -8px;
            }

            .ant-btn {
                margin-top: 10px;
            }

            .switch {
                margin: 50px 0;
                cursor: pointer;
                text-align: center;
            }
        }

        footer {
            left: 0;
            right: 0;
            bottom: 30px;
            color: #888;
            position: absolute;
        }
    }
</style>
